import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import autoBind from 'react-autobind';
import { browserHistory } from 'react-router';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import Checkbox from 'material-ui/Checkbox';
import RaisedButton from 'material-ui/RaisedButton';
import { cyan900 } from 'material-ui/styles/colors';
import _ from 'lodash';

const propTypes = {
  product: PropTypes.object,
  onSave: PropTypes.func,
  categories: PropTypes.any,
};

class ViewProduct extends Component {
  constructor(props) {
    super(props);
    this.state = {
      product: {
        id: 0,
        name: '',
        description: '',
        categories: '',
        disabled: true,
        newproduct: false,
        defaultItemId: 0,
        optionGroups: [],
        optionItems: [],
        img: '',
        allowsPersonalization: false,
        bleed: {
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
        },
        altImages: [],
        parentCategory: 0,
        relatedCategory: 0,
      },
      open: false,
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }

  // componentDidMount(){
  //    this.props.dispatch(fetchCatalogsByProductId(this.props.product.id))
  // }

  componentWillReceiveProps(nextProps) {
    const catalogs = nextProps.catalogs;
    this.setState({ catalogs });
    if (nextProps.product) {
      const product = nextProps.product;
      product.parCatName = _.result(_.find(this.props.categories, { id: this.state.product.parentCategory }), 'name') || '';
      product.relCatName = _.result(_.find(this.props.categories, { id: this.state.product.relatedCategory }), 'name') || '';
      product.defaultItemId = (product.defaultItemId === null) ? 0 : product.defaultItemId;
      this.setState({ product });
    }
  }
  navigateToEdit() {
    browserHistory.push(`/products/${this.props.product.id}`);
  }
  handleCancel() {
    browserHistory.push('/products');
  }
  render() {
    const catalogs = this.state.catalogs;
    const styles = {
      floatingLabelStyle: {
        color: cyan900,
      },
      inputStyle: {
        marginRight: '2%',
        width: '250px',
      },
      wideStyle:{
        marginRight: '2%',
        width: '700px',
      },
      inputStyleURL: {
        marginRight: '1%',
        width: '100%'
      },
    };
    return (
      <div>
        <div className="float-right">
          <RaisedButton
            style={{ marginRight: '20px' }}
            label="Cancel"
            primary
            onClick={this.handleCancel}
          />
          <RaisedButton
            label="Edit"
            primary
            onClick={this.navigateToEdit}
          />
        </div>
        <SelectField
          value=""
          // onChange={(event, index, value) => this.handleFilterChange(event, index, value)}
          floatingLabelText="Catalogs"
          style={{ verticalAlign: 'bottom', marginRight: '2%', width: '250px', float: 'right' }}
          name="catalog"
          floatingLabelStyle={styles.floatingLabelStyle}
        >
          {catalogs && catalogs.map((catalog) => <MenuItem value={catalog.id} primaryText={catalog.name} />)}

        </SelectField>
        <br />
        <TextField
          floatingLabelText="ID"
          floatingLabelStyle={styles.floatingLabelStyle}
          floatingLabelFixed={true}
          inputStyle={styles.inputStyle}
          value={this.state.product.id}
        />
        <br />
        <TextField
          floatingLabelText="Name"
          floatingLabelStyle={styles.floatingLabelStyle}
          floatingLabelFixed={true}
          value={this.state.product.name}
          name="name"
          style={styles.inputStyle}
        />
        <TextField
          floatingLabelText="Tagline"
          floatingLabelStyle={styles.floatingLabelStyle}
          floatingLabelFixed={true}
          value={this.state.product.tagline}
          name="tagline"
          style={styles.inputStyle}
          multiLine={true}
        />
        <TextField
          floatingLabelText="Parent Category"
          floatingLabelStyle={styles.floatingLabelStyle}
          floatingLabelFixed={true}
          value={this.state.product.parCatName}
          name="parentCategory"
          style={styles.inputStyle}
        />
        <TextField
          floatingLabelText="Related Category"
          floatingLabelStyle={styles.floatingLabelStyle}
          floatingLabelFixed={true}
          value={this.state.product.relCatName}
          name="relatedCategory"
          style={styles.inputStyle}
        />
        <TextField
          floatingLabelText="Yotpo ID"
          floatingLabelStyle={styles.floatingLabelStyle}
          floatingLabelFixed={true}
          value={this.state.product.yotpoId}
          name="yotpoId"
          style={styles.inputStyle}
        />
        <TextField
          floatingLabelText="Image"
          floatingLabelStyle={styles.floatingLabelStyle}
          floatingLabelFixed={true}
          value={this.state.product.img}
          name="img"
          style={styles.inputStyleURL}
        />
        <br/>
        <TextField
          floatingLabelText="Description"
          floatingLabelStyle={styles.floatingLabelStyle}
          floatingLabelFixed={true}
          value={this.state.product.description}
          name="description"
          style={styles.wideStyle}
          multiLine={true}
        />
        <br />
        <br />
        <ul>
        <li>
            <Checkbox
              label="New Product"
              checked={this.state.product.newproduct}
              name="newproduct"
            />
          </li>
          <li>
            <Checkbox
              label="Disabled"
              checked={this.state.product.disabled}
              name="disabled"
            />
          </li>
          <li>
            <Checkbox
              label="Product is Taxable"
              defaultChecked={this.state.product.isTaxable}
              name="isTaxable"
            />
          </li>
          <li>
            <Checkbox
              label="Allows Personalization"
              checked={this.state.product.allowsPersonalization}
              name="allowsPersonalization"
            />
          </li>
          <li>
            <Checkbox
              label="Bleed"
              checked={this.state.product.bleed}
              name="bleed"
            />
          </li>
        </ul>
      </div>
    );
  }
}

ViewProduct.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

ViewProduct.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    product: state.products.product,
    categories: state.categories.results,
    catalogs: state.products.catalogs,
  };
}

export default connect(mapStateToProps)(ViewProduct);



// WEBPACK FOOTER //
// ./src/components/products/ViewProduct.js